import _slicedToArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createSafeContext } from '@mantine/utils';
var _createSafeContext = createSafeContext("Grid component was not found in tree"),
  _createSafeContext2 = _slicedToArray(_createSafeContext, 2),
  GridProvider = _createSafeContext2[0],
  useGridContext = _createSafeContext2[1];
export { GridProvider, useGridContext };